import React, { useEffect, useMemo, useState } from "react"
import { DatePicker as Dtpicker } from '@material-ui/lab';
import { TextField } from "@material-ui/core";
import { dateToString } from "./DateTimePickerOqt";
import moment from "moment";

export const DatePickerOqt = ({name, details = false, caption = "Fecha", formik, variant = "outlined", placeholder, onChange, minDate, invalidDateMessage, minDateMessage, maxDateMessage}) => {


  const formikValue = formik.values[name];

  const [value, setValue] = useState(!!formikValue ? moment(formikValue) : null);

  useEffect(()=>{
      formik.setFieldValue(name, dateToString(value));
  }, [value]);


  return (
    <div style={{ padding: 8 }}>
      <Dtpicker
        disabled={details}
        label={variant == "outlined" && caption}
        value={value}
        onChange={(value)=>{ 
          setValue(value)
        }}
        renderInput={(params) => <TextField {...params}  helperText="" fullWidth variant={variant} />}
      />
    </div>
  )
}

